import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartRadar } from './useGetChartRadar'
import { ChartRadarContent } from './ChartRadarContent'

export const ChartRadarComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartRadar(id, tileFilterSelections)

  return (
    <ChartRadarContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartRadarComponentLoading() {
  return 'Loading...'
}
